import React, { useContext } from 'react';
import { Form, Button } from 'semantic-ui-react';
import ModalTransition from '../../ModalTransition/ModalTransition';
import GlobalContext from '../../../contexts/GlobalContext';

const ModalConfirmUpdateBankCard = (props) => {
  const [globalContext] = useContext(GlobalContext);

  /**
   * Retourne la liste des bouttons de la modal
   * @returns Object
   */
  const getAction = () => {
    return (
      <div>
        <Button
          color="grey"
          icon="delete"
          labelPosition="right"
          content={globalContext.translations.preCheckInCancel}
          onClick={props.handleClose}
        />
        <Button
          positive
          icon="checkmark"
          labelPosition="right"
          content={globalContext.translations.validate}
          onClick={() => {
            props.onConfirm()
            props.handleClose()
          }}
        />
      </div>
    )
  }

  return (
    <ModalTransition
      size="tiny"
      open={props.open}
      handleClose={props.handleClose}
      header={globalContext.translations.confirmSetUseHeader}
      content={
        <Form>
          <div>
            {props.bankCardConfimUsing === 'stay' ? globalContext.translations.confirmSetStayContent : globalContext.translations.confirmSetPrestayContent}
          </div>
        </Form>
      }
      actions={
        getAction()
      }
    />
  )
}

export default ModalConfirmUpdateBankCard;